module.exports = __webpack_public_path__ + "img/预留灵活空间.c35435c7.webp";